const CONDO_PROPERTIES_TABLE_RETURN_KEY = "condo-properties-table-return"
const RETURN_STATE_MAX_AGE_MS = 30 * 60 * 1000

export type CondoPropertiesTableReturnState = {
   returnTo: string
   selectedPropertyId: string
   scrollY: number
   visibleCount: number
   sortOption: string
   createdAt: number
}

const isCondoPropertiesTableReturnState = (
   value: unknown,
): value is CondoPropertiesTableReturnState => {
   if (!value || typeof value !== "object") return false

   const state = value as Partial<CondoPropertiesTableReturnState>
   return (
      typeof state.returnTo === "string" &&
      typeof state.selectedPropertyId === "string" &&
      typeof state.scrollY === "number" &&
      typeof state.visibleCount === "number" &&
      typeof state.sortOption === "string" &&
      typeof state.createdAt === "number"
   )
}

export const readCondoPropertiesTableReturnState = () => {
   const value = sessionStorage.getItem(CONDO_PROPERTIES_TABLE_RETURN_KEY)

   if (!value) {
      return null
   }

   try {
      const parsed = JSON.parse(value)
      if (!isCondoPropertiesTableReturnState(parsed)) {
         return null
      }
      if (Date.now() - parsed.createdAt > RETURN_STATE_MAX_AGE_MS) {
         sessionStorage.removeItem(CONDO_PROPERTIES_TABLE_RETURN_KEY)
         return null
      }
      return parsed
   } catch {
      sessionStorage.removeItem(CONDO_PROPERTIES_TABLE_RETURN_KEY)
      return null
   }
}

export const hasCondoPropertiesTableReturnState = (returnTo: string) =>
   readCondoPropertiesTableReturnState()?.returnTo === returnTo

export const saveCondoPropertiesTableReturnState = (state: CondoPropertiesTableReturnState) => {
   sessionStorage.setItem(CONDO_PROPERTIES_TABLE_RETURN_KEY, JSON.stringify(state))
}

export const clearCondoPropertiesTableReturnState = () => {
   sessionStorage.removeItem(CONDO_PROPERTIES_TABLE_RETURN_KEY)
}
